module.exports = __webpack_public_path__ + "static/img/ys2.34020b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/control2/ys2.png
// module id = BmJH
// module chunks = 7